/* SET STATE */
export const SET_STATE_QUOTATION = "SET_STATE_QUOTATION"

/* QUOTATIONS */
export const GET_QUOTATIONS = "GET_QUOTATIONS"
export const GET_QUOTATIONS_SUCCESS = "GET_QUOTATIONS_SUCCESS"
export const GET_QUOTATIONS_FAIL = "GET_QUOTATIONS_FAIL"

/* QUOTATION */
export const GET_QUOTATION = "GET_QUOTATION"
export const GET_QUOTATION_SUCCESS = "GET_QUOTATION_SUCCESS"
export const GET_QUOTATION_FAIL = "GET_QUOTATION_FAIL"

/**
 * ADD QUOTATION
 */
 export const ADD_NEW_QUOTATION = "ADD_NEW_QUOTATION"
 export const ADD_QUOTATION_SUCCESS = "ADD_QUOTATION_SUCCESS"
 export const ADD_QUOTATION_FAIL = "ADD_QUOTATION_FAIL"

 /**
 * UPDATE QUOTATION
 */
export const UPDATE_QUOTATION = "UPDATE_QUOTATION"
export const UPDATE_QUOTATION_STATUS = "UPDATE_QUOTATION_STATUS"
export const UPDATE_QUOTATION_SUCCESS = "UPDATE_QUOTATION_SUCCESS"
export const UPDATE_QUOTATION_FAIL = "UPDATE_QUOTATION_FAIL"

/**
 * DELETE QUOTATION
 */
export const DELETE_QUOTATION = "DELETE_QUOTATION"
export const DELETE_QUOTATION_SUCCESS = "DELETE_QUOTATION_SUCCESS"
export const DELETE_QUOTATION_FAIL = "DELETE_QUOTATION_FAIL"
